import axios from "axios";
import apiClient from "./client";
import { getApiBaseUrl } from "../config/apiBase";

const toSafePdfFileName = (originalName) => {
  const raw = String(originalName || "upload.pdf").trim();
  const withoutExt = raw.replace(/\.pdf$/i, "");
  const safeBase = withoutExt
    .normalize("NFKD")
    .replace(/[^\w.-]+/g, "-")
    .replace(/\.+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
  return `${safeBase || "upload"}.pdf`;
};

export const getAdminDownloads = async () => {
  const response = await apiClient.get("/downloads/admin");
  return response.data;
};

export const createAdminDownload = async (payload) => {
  const response = await apiClient.post("/downloads/admin", payload);
  return response.data;
};

export const updateAdminDownload = async ({ id, payload }) => {
  const response = await apiClient.put(`/downloads/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminDownload = async ({ id }) => {
  await apiClient.delete(`/downloads/admin/${id}`);
};

export const uploadAdminDownloadFile = async ({ id, file }) => {
  if (!file) {
    throw new Error("Please select a PDF file.");
  }

  const isPdfByMime = String(file.type || "").toLowerCase() === "application/pdf";
  const isPdfByName = /\.pdf$/i.test(String(file.name || ""));

  if (!isPdfByMime && !isPdfByName) {
    throw new Error("Only PDF files are allowed.");
  }

  const formData = new FormData();
  formData.append("file", file, toSafePdfFileName(file.name));

  const token = localStorage.getItem("irqgyp_auth_token");

  const response = await axios.post(
    `${getApiBaseUrl()}/downloads/admin/${id}/file`,
    formData,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    }
  );

  return response.data;
};

export const removeAdminDownloadFile = async ({ id }) => {
  const response = await apiClient.delete(`/downloads/admin/${id}/file`);
  return response.data;
};
